<template>
  <div class="content-v2">
    <section class="honor-section">
      <div class="honor-section-head">
        <span>{{ sectionMeta.enTitle }}</span>
        <h2>{{ sectionMeta.title }}</h2>
      </div>
      <div class="honors-grid-v2">
        <div class="honor-card" v-for="item in displayHonorList" :key="item.id">
          <div class="honor-img">
            <img :src="item.image" :alt="item.name" />
          </div>
          <p>{{ item.name }}</p>
          <span v-if="item.issuer || item.date">{{ item.issuer }} {{ item.date }}</span>
        </div>
      </div>
      <div v-if="!displayHonorList.length" class="empty-state">暂无内容</div>
    </section>
  </div>
</template>

<script>
import { getHonorList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultHonorImage from '@/assets/images/case1.svg'

export default {
  name: 'AboutHonorsV2',
  data() {
    return {
      honorList: []
    }
  },
  created() {
    this.loadHonorList()
  },
  watch: {
    activeType() {
      this.loadHonorList()
    }
  },
  computed: {
    activeType() {
      return this.$route.meta.honorType || 'qualification'
    },
    sectionMeta() {
      return this.activeType === 'award'
        ? { title: '荣誉奖项', enTitle: 'HONORS & AWARDS' }
        : { title: '资质体系', enTitle: 'QUALIFICATION SYSTEM' }
    },
    displayHonorList() {
      return this.honorList.filter(item => (item.type || 'qualification') === this.activeType)
    }
  },
  methods: {
    loadHonorList() {
      getHonorList({ pageNum: 1, pageSize: 50, honorType: this.activeType }).then(list => {
        if (!list || !list.length) {
          this.honorList = []
          return
        }
        this.honorList = list.map(item => ({
          id: item.honorId,
          name: item.honorName,
          type: item.honorType || 'qualification',
          image: resolveFileUrl(item.imageUrl, defaultHonorImage),
          issuer: item.issuer || '',
          date: item.honorDate || ''
        }))
      }).catch(() => {
        this.honorList = []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.honor-section + .honor-section {
  margin-top: 58px;
}

.honor-section-head {
  margin-bottom: 24px;

  span {
    color: #2563eb;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 4px;
  }

  h2 {
    margin: 10px 0 0;
    color: #0f172a;
    font-size: 32px;
    font-weight: 800;
  }
}

.honors-grid-v2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.honor-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 8px 30px rgba(0,0,0,0.08);
  }

  .honor-img {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 12px;

    img {
      width: 100%;
      display: block;
    }
  }

  p {
    font-size: 14px;
    color: #475569;
  }

  span {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #94a3b8;
  }
}

@media (max-width: 960px) {
  .honors-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.empty-state {
  padding: 48px 0;
  color: #94a3b8;
  text-align: center;
  background: #fff;
  border: 1px dashed #cbd5e1;
}
</style>
